import React, { createContext, useState, useContext } from 'react';
import type { ReactNode } from 'react';

export const PricesBedroomFilterContext = createContext<
  (
    | {
        name: string;
        value: string;
      }
    | {
        name: string;
        value: string[];
      }
  )[]
>([
  { name: 'pricePeriod', value: 'PerWeek' },
  { name: 'price', value: ['', ''] },
  {
    name: 'bedrooms_from',
    value: ''
  }
]);

export const PricesBedroomFilterUpdaterContext = createContext<
  React.Dispatch<
    React.SetStateAction<
      (
        | {
            name: string;
            value: string;
          }
        | {
            name: string;
            value: string[];
          }
      )[]
    >
  >
>(() => {});

interface PricesBedroomFilterProviderProps {
  children: ReactNode;
}

export const usePricesBedroomFilterContext = () => {
  const filters = useContext(PricesBedroomFilterContext);

  return filters;
};

export const useGetPricesBedroomFilterLinkContext = () => {
  const filters = useContext(PricesBedroomFilterContext);
  const priceRange = filters.find((filter) => filter.name === 'price').value;
  const bedrooms = filters.find(
    (filter) => filter.name === 'bedrooms_from'
  ).value;
  let filtersUrl = bedrooms ? `/${bedrooms}-bedroom` : '';
  const searchParams = new URLSearchParams();

  if (priceRange[0]) {
    searchParams.append('price_from', priceRange[0]);
  }

  if (priceRange[1]) {
    searchParams.append('price_to', priceRange[1]);
  }

  const queryString = searchParams.toString();

  filtersUrl += queryString ? `?${queryString}` : '';

  return filtersUrl;
};

export const usePricesBedroomFilterUpdaterContext = () => {
  const setFilters = useContext(PricesBedroomFilterUpdaterContext);

  return setFilters;
};

export function PricesBedroomFilterProvider({
  children
}: PricesBedroomFilterProviderProps) {
  const [filters, setFilters] = useState([
    { name: 'pricePeriod', value: 'PerWeek' },
    { name: 'price', value: ['', ''] },
    {
      name: 'bedrooms_from',
      value: ''
    }
  ]);

  return (
    <PricesBedroomFilterContext.Provider value={filters}>
      <PricesBedroomFilterUpdaterContext.Provider value={setFilters}>
        {children}
      </PricesBedroomFilterUpdaterContext.Provider>
    </PricesBedroomFilterContext.Provider>
  );
}
